"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchUploadAvatar = watchUploadAvatar;
exports.watchDeleteAvatar = watchDeleteAvatar;
exports.watchFetchProfilePictures = watchFetchProfilePictures;
exports.watchUserProfilesForPictures = watchUserProfilesForPictures;
exports.watchAuthForCurrentProfilePicture = watchAuthForCurrentProfilePicture;
var get_1 = __importDefault(require("lodash/get"));
var immutable_1 = require("immutable");
var config_1 = require("config");
var apollo_graphql_1 = require("services/apollo-graphql");
var auth_1 = require("services/auth");
var error_1 = require("log/error");
var actions_1 = require("services/auth/actions");
var actions_2 = require("services/user-profiles/actions");
var query_1 = require("services/community/query");
var actions = __importStar(require("./actions"));
var watcherConfig = (0, config_1.get)();
var communityProfileEnabled = !!(watcherConfig && watcherConfig.features
    && watcherConfig.features.communityProfile);
var CONTENT_TYPE_MAP = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
};
// ── Helpers ──────────────────────────────────────────────────────────
function getAuthToken(state) {
    return immutable_1.Map.isMap(state.auth) ? state.auth.get('jwt') : '';
}
// ── Watchers ─────────────────────────────────────────────────────────
/**
 * Upload a profile picture via a presigned S3 URL.
 * Flow: requestProfilePictureUpload -> PUT to S3 -> confirmProfilePictureUpload
 */
function watchUploadAvatar(_a) {
    var _this = this;
    var after = _a.after;
    return after(actions.COMMUNITY_PROFILE_UPLOAD_AVATAR, function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
        var _c, imageBlob, fileExtension, authToken, data, uploadRequest, contentType, uploadResponse, confirmResult, confirmed, uid, err_1, error;
        var _d;
        var dispatch = _b.dispatch, state = _b.state, action = _b.action;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    dispatch(actions.setAvatarUploadProcessing(true));
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 5, 6, 7]);
                    _c = action.payload, imageBlob = _c.imageBlob, fileExtension = _c.fileExtension;
                    authToken = getAuthToken(state);
                    return [4 /*yield*/, apollo_graphql_1.client.mutate({
                            mutation: query_1.CREATE_PROFILE_PICTURE_UPLOAD,
                            variables: { fileExtension: fileExtension || 'png' },
                            context: { jwt: authToken },
                            fetchPolicy: apollo_graphql_1.APOLLO_CLIENT_FETCH_POLICY_NETWORK_ONLY,
                        })];
                case 2:
                    data = (_e.sent()).data;
                    uploadRequest = data.requestProfilePictureUpload;
                    contentType = CONTENT_TYPE_MAP[fileExtension] || 'image/png';
                    return [4 /*yield*/, fetch(uploadRequest.uploadUrl, {
                            method: 'PUT',
                            body: imageBlob,
                            headers: { 'Content-Type': contentType },
                        })];
                case 3:
                    uploadResponse = _e.sent();
                    if (!uploadResponse.ok) {
                        throw new Error("Profile image S3 upload failed: ".concat(uploadResponse.status));
                    }
                    return [4 /*yield*/, apollo_graphql_1.client.mutate({
                            mutation: query_1.CREATE_PROFILE_PICTURE_CONFIRM,
                            variables: {
                                imageUuid: uploadRequest.imageUuid,
                                imageExtension: fileExtension || 'png',
                            },
                            context: { jwt: authToken },
                        })];
                case 4:
                    confirmResult = _e.sent();
                    confirmed = confirmResult.data.confirmProfilePictureUpload;
                    dispatch(actions.setAvatarUploadSuccess());
                    uid = immutable_1.Map.isMap(state.auth) ? state.auth.get('uid') : undefined;
                    if (uid && confirmed.profilePicture) {
                        dispatch(actions.setProfilePictures((_d = {},
                            _d[String(uid)] = confirmed.profilePicture,
                            _d)));
                    }
                    return [3 /*break*/, 7];
                case 5:
                    err_1 = _e.sent();
                    error = err_1 instanceof Error ? err_1 : new Error(String(err_1));
                    (0, error_1.log)(error, 'Community profile avatar upload failed');
                    dispatch(actions.setAvatarUploadError(error.message));
                    return [3 /*break*/, 7];
                case 6:
                    dispatch(actions.setAvatarUploadProcessing(false));
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); })
        .when(function (_a) {
        var state = _a.state;
        return (0, auth_1.getAuthIsLoggedIn)(state.auth);
    });
}
/**
 * Delete the current user's profile picture via GraphQL.
 */
function watchDeleteAvatar(_a) {
    var _this = this;
    var after = _a.after;
    return after(actions.COMMUNITY_PROFILE_DELETE_AVATAR, function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
        var authToken, uid, err_2, error;
        var _c;
        var dispatch = _b.dispatch, state = _b.state;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    dispatch(actions.setAvatarDeleteProcessing(true));
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    authToken = getAuthToken(state);
                    return [4 /*yield*/, apollo_graphql_1.client.mutate({
                            mutation: query_1.DELETE_PROFILE_PICTURE,
                            context: { jwt: authToken },
                        })];
                case 2:
                    _d.sent();
                    dispatch(actions.setAvatarDeleteSuccess());
                    uid = immutable_1.Map.isMap(state.auth) ? state.auth.get('uid') : undefined;
                    if (uid) {
                        dispatch(actions.setProfilePictures((_c = {},
                            _c[String(uid)] = { url: '', small: '', card: '' },
                            _c)));
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _d.sent();
                    error = err_2 instanceof Error ? err_2 : new Error(String(err_2));
                    (0, error_1.log)(error, 'Community profile avatar delete failed');
                    dispatch(actions.setAvatarDeleteError(error.message));
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(actions.setAvatarDeleteProcessing(false));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); })
        .when(function (_a) {
        var state = _a.state;
        return (0, auth_1.getAuthIsLoggedIn)(state.auth);
    });
}
/**
 * Fetch profile pictures by uid via GraphQL.
 * Skips uids already cached in profilePictures.data.
 */
function watchFetchProfilePictures(_a) {
    var _this = this;
    var after = _a.after;
    return after(actions.COMMUNITY_PROFILE_FETCH_PROFILE_PICTURES, function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
        var uids, cached_1, uncached, authToken, results_1, data, users, err_3, error;
        var dispatch = _b.dispatch, state = _b.state, action = _b.action;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!communityProfileEnabled)
                        return [2 /*return*/];
                    dispatch(actions.setProfilePicturesProcessing(true));
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    uids = action.payload.uids;
                    if (!uids || uids.length === 0)
                        return [2 /*return*/];
                    cached_1 = immutable_1.Map.isMap(state.communityProfile)
                        ? state.communityProfile.getIn(['profilePictures', 'data'])
                        : (0, immutable_1.Map)();
                    uncached = uids.filter(function (uid) { return !cached_1.has(String(uid)); });
                    if (uncached.length === 0)
                        return [2 /*return*/];
                    authToken = getAuthToken(state);
                    results_1 = {};
                    return [4 /*yield*/, apollo_graphql_1.client.query({
                            query: query_1.GET_AVATARS_BATCH,
                            variables: { uids: uncached.map(String) },
                            fetchPolicy: apollo_graphql_1.APOLLO_CLIENT_FETCH_POLICY_NETWORK_ONLY,
                            errorPolicy: apollo_graphql_1.APOLLO_CLIENT_ERROR_POLICY_ALL,
                            context: { jwt: authToken },
                        })];
                case 2:
                    data = (_c.sent()).data;
                    users = (0, get_1.default)(data, 'userInfoPublic', []) || [];
                    users.forEach(function (user) {
                        if (user && user.uid && user.avatar) {
                            results_1[String(user.uid)] = user.avatar;
                        }
                    });
                    if (Object.keys(results_1).length > 0) {
                        dispatch(actions.setProfilePictures(results_1));
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_3 = _c.sent();
                    error = err_3 instanceof Error ? err_3 : new Error(String(err_3));
                    (0, error_1.log)(error, 'Profile pictures batch fetch failed');
                    dispatch(actions.setProfilePicturesError(error.message));
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(actions.setProfilePicturesProcessing(false));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); })
        .when(function (_a) {
        var state = _a.state;
        return (0, auth_1.getAuthIsLoggedIn)(state.auth);
    });
}
/**
 * When user profiles are loaded (multi-profile list), automatically
 * fetch profile pictures for all uids via GraphQL.
 */
function watchUserProfilesForPictures(_a) {
    var _this = this;
    var after = _a.after;
    return after(actions_2.USER_PROFILES_SET, function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
        var profiles, uids;
        var dispatch = _b.dispatch, state = _b.state;
        return __generator(this, function (_c) {
            if (!communityProfileEnabled)
                return [2 /*return*/];
            profiles = immutable_1.Map.isMap(state.userProfiles)
                ? state.userProfiles.get('data')
                : undefined;
            if (!profiles || !immutable_1.Map.isMap(profiles) || profiles.size === 0)
                return [2 /*return*/];
            uids = profiles
                .map(function (p) { return (immutable_1.Map.isMap(p) ? p.get('uid') : undefined); })
                .filter(Boolean)
                .toJS();
            if (uids.length > 0) {
                dispatch(actions.fetchProfilePictures(uids));
            }
            return [2 /*return*/];
        });
    }); })
        .when(function (_a) {
        var state = _a.state;
        return (0, auth_1.getAuthIsLoggedIn)(state.auth);
    });
}
/**
 * When auth data is set (login / page load), fetch the current user's
 * profile picture so the nav-bar avatar renders immediately.
 */
function watchAuthForCurrentProfilePicture(_a) {
    var _this = this;
    var after = _a.after;
    return after(actions_1.SET_AUTH_DATA, function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
        var uid, cached;
        var dispatch = _b.dispatch, state = _b.state;
        return __generator(this, function (_c) {
            if (!communityProfileEnabled)
                return [2 /*return*/];
            uid = immutable_1.Map.isMap(state.auth) ? state.auth.get('uid') : undefined;
            if (!uid)
                return [2 /*return*/];
            cached = immutable_1.Map.isMap(state.communityProfile)
                ? state.communityProfile.getIn(['profilePictures', 'data', String(uid)])
                : undefined;
            if (cached && cached.size > 0)
                return [2 /*return*/];
            dispatch(actions.fetchProfilePictures([uid]));
            return [2 /*return*/];
        });
    }); })
        .when(function (_a) {
        var state = _a.state;
        return (0, auth_1.getAuthIsLoggedIn)(state.auth);
    });
}
